import { get, put,Delete,post } from '../axios'

// 反馈列表-列表
export const feedbackManageList = params => get(`/web/feedback/manage/list`,params);



